import { render, staticRenderFns } from "./BeyondTheWallArticle.vue?vue&type=template&id=8b7bb7a8&"
import script from "./BeyondTheWallArticle.vue?vue&type=script&lang=js&"
export * from "./BeyondTheWallArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports